import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import dayjs from 'dayjs';
import { RequestStateEnum } from '../../../../enums/app.enum';
import { ModalService } from '../../../../services/modal.service';
import { TodaysActivityStore } from '../../../../stores/today-activities.store';
import { ButtonComponent } from '../../../atoms/button/button.component';
import { CardHeaderComponent } from '../../../atoms/card-header/card-header.component';
import { CardComponent } from '../../../atoms/card/card/card.component';
import { NoEntriesPlaceholderComponent } from '../../../molecules/no-entries-placeholder/no-entries-placeholder.component';
import { activityTypeLabels } from '../../../organisms/activities/activities.constants';
import { Activity } from '../../../organisms/activities/activities.types';
import { MainLayoutComponent } from '../../../organisms/main-layout/main-layout.component';
import { ModalManualCheckInComponent } from '../../../organisms/modal/modal-manual-check-in/modal-manual-check-in.component';
import { ModalShowCheckedInUsersComponent } from '../../../organisms/modal/modal-show-checked-in-users/modal-show-checked-in-users.component';
import { ModalShowQrCodeComponent } from '../../../organisms/modal/modal-show-qr-code/modal-show-qr-code.component';
import { CheckInItemComponent } from '../../user/check-in/check-in-item/check-in-item.component';

@Component({
  selector: 'app-coach-check-in',
  imports: [
    MainLayoutComponent,
    CardComponent,
    CardHeaderComponent,
    NoEntriesPlaceholderComponent,
    CheckInItemComponent,
    ButtonComponent,
  ],
  templateUrl: './coach-check-in.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoachCheckinComponent implements OnInit {
  protected RequestStateEnum = RequestStateEnum;
  protected dayjs = dayjs;

  private readonly modalService = inject(ModalService);
  private readonly todayActivityStore = inject(TodaysActivityStore);

  public requestState = this.todayActivityStore.requestState;
  public activities = this.todayActivityStore.entities;

  ngOnInit(): void {
    this.todayActivityStore.load();
  }

  public getActivityLabel(activity: Activity): string {
    return activityTypeLabels[activity.type];
  }

  public showQrCodeModal(activity: Activity): void {
    this.modalService.openOverlayWithConfig(ModalShowQrCodeComponent, { activity });
  }

  public showManualCheckInModal(activity: Activity): void {
    this.modalService.openOverlayWithConfig(ModalManualCheckInComponent, { activity });
  }

  public showCheckedInUsersModal(activity: Activity): void {
    this.modalService.openOverlayWithConfig(ModalShowCheckedInUsersComponent, {
      activityId: activity.id,
    });
  }
}
